export const enum StakingPoolTypeEnum {
  FIXED = 0,
  COMPOUND = 1,
}

export const StakingPoolTypeLabel = [
  { label: 'Fixed', value: StakingPoolTypeEnum.FIXED },
  { label: 'Compound', value: StakingPoolTypeEnum.COMPOUND },
]

export const enum CompoundTypeEnum {
  DAILY = 0,
  WEEKLY = 1,
  MONTHLY = 2,
}

export const CompoundTypeLabel = [
  { label: 'Daily', value: CompoundTypeEnum.DAILY },
  { label: 'Weekly', value: CompoundTypeEnum.WEEKLY },
  { label: 'Monthly', value: CompoundTypeEnum.MONTHLY },
]

export const enum StakingTokenTypeEnum {
  /**
   * Lock period 3 months
   */
  TYPE_3M = 1,
  /**
   * Lock period 6 months
   */
  TYPE_6M = 2,
  /**
   * Lock period 12 months
   */
  TYPE_12M = 3,
}

export const StakingTokenTypeLabel = [
  {
    label: '3 Months',
    value: StakingTokenTypeEnum.TYPE_3M,
    labelClassName: 'status-pending',
  },
  {
    label: '6 Months',
    value: StakingTokenTypeEnum.TYPE_6M,
    labelClassName: 'status-fail',
  },
  {
    label: '12 Months',
    value: StakingTokenTypeEnum.TYPE_12M,
    labelClassName: 'status-success',
  },
]
